import type { FaireProductEntity } from "../../entity_types/product";

export const p_cxv6gwr4yv: FaireProductEntity = {
  token: "p_cxv6gwr4yv",
  type: "product",
  name: "Birdie Little Notes® Duo Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9397d01908bb220c7e83c39d587f5c4d179efd86ecad372185a5729d1787f230.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b6a6f6f9914aaa73c421717866afa9414bfe323a26124b8f8152e5043965aebf.jpeg",
    "https://cdn.faire.com/fastly/a34225c805f525e1756f11d65e4cd7b433a241a56462afaa66e79d0637e93366.jpeg",
    "https://cdn.faire.com/fastly/aacfb6d53e135316aa9748bfbf2554b1a5ec6fa2fe4cf0246b06d10242383236.jpeg",
    "https://cdn.faire.com/fastly/94a7eedee79fe83b4ee3db92ccf44688f22ad9d26bf2b72ea58e677ea7fc1252.jpeg",
  ],
  priceDollars: 6,
  description:
    "The cutest little duos you ever did see. Set of 10 Little Notes®and 10 Little Note Envelopes. These corresponding Little Notes® and printed envelopes take the surprise and delight of Little Notes to the next level - so up your gift tag/secret note/barista tip game! Please note: These envelopes are so adorably tiny that they're too small for the postal service, so hand-deliver only!",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:25.547Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
